import 'leaflet';
import BaseIcon from './BaseIcon';
import Vue from 'vue';
import MapIconObject from '../../../components/map-icon/map-icon-object.vue';
import MapIconIconVue from '../../../components/map-icon/map-icon-vue.vue';

const IconObject = BaseIcon.extend({
  getVueComponent: function () {
    return new Vue(MapIconObject)
  }
})

const IconCar = BaseIcon.extend({
  getVueComponent: function () {
    return new Vue(MapIconIconVue)
  }
})

const IconGarbage = BaseIcon.extend({
  getVueComponent: function () {
    return new Vue(MapIconObject)
  }
})

export {IconObject, IconCar, IconGarbage}
